import LogInModel from '../models/login.model'

let storeContent = utils.generateStore({
   LogInModel,
})

export default {
   state: {
      ...storeContent.state
   },
   getters: {
      ...storeContent.getters
   },
   mutations: {
      ...storeContent.mutations
   },
   actions: {
      async logIn(ctx, payload) {
         try {
            console.log(payload)
            ctx.commit('loading', true)
            let data = payload.ref.formData_

            if (await payload.ref.isValid()) {
               let res = await api.fetchEndpoint({
                  resource: "auth",
                  action: "login",
                  data: {
                     email: data.email,
                     password: data.password,
                  },
                  meta_data: {}
               });
               
               await $session.set('user', res.result.user)
               await $session.set('token', res.result.token)
               payload.router.push({ name: 'Dashboard'})
            }

            ctx.commit('loading', false)
         } catch (err) {
            ctx.commit('loading', false)
            throw err
         }
      },
      async toggleLoginTab(ctx) {
         ctx.commit('showLogIn', !ctx.getters.showLogIn)
      },
   }
};